export default __webpack_public_path__ + "static/media/five.587fb611.jpeg";